import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useFilter from '../hooks/useFilter';

export default function Historical() {
    const axiosPrivate = useAxiosPrivate();
    const { filter } = useFilter();
    const [loading, setLoading] = useState(true);
    const [hasHistoricalCompletions, setHasHistoricalCompletions] = useState(false);
    const [includeHistoricalCompletions, setIncludeHistoricalCompletions] = useState(false);
    const [helpText, setHelpText] = useState("");

    useEffect(() => {
        const getHistoricalCheck = async () => {
            if (filter?.formHasHistoricalCompletions)
            {
                if (filter.includeHistoricalCompletions) {
                    setIncludeHistoricalCompletions(filter.includeHistoricalCompletions);
                }
            }
            else
            {
                try{
                    await axiosPrivate.get('/api/core/courses/checkhistorical')
                        .then(response => {
                            setHasHistoricalCompletions(response.data);
                        });
                }
                catch(err){
                    console.log(err);
                }
            }            
        };
        getHistoricalCheck().then(function(){
            setLoading(false);
        });
    }, []);

    const onIncludeHistoricalCompletionsChange = (e) => {
        setIncludeHistoricalCompletions(e.target.checked);
    };  

    return ({
        loading, hasHistoricalCompletions, includeHistoricalCompletions, setHelpText,
        render:

            <>
                {
                    hasHistoricalCompletions ?
                        <>
                            <Row>
                                <Col xs="6">
                                    <h5>Migrated Data</h5>
                                    {helpText}
                                </Col>
                                <Col xs="6">
                                    <div>
                                        <input type='checkbox' onChange={onIncludeHistoricalCompletionsChange} checked={includeHistoricalCompletions} /> Include Migrated Data
                                    </div>
                                </Col>
                            </Row>
                        </>
                        :
                        null
                }

            </>
    });
}